import { defineMessages } from 'react-intl';

export default defineMessages({
    enterYourDetailsHeader: {
        id: 'enrollment.components.enrollment.Enter Your Details',
        defaultMessage: 'Enter Your Details'
    },
    enroll: {
        id: 'enrollment.components.enrollment.Enroll',
        defaultMessage: 'Enroll'
    },
    enrollmentAddressLine1: {
        id: 'enrollment.components.enrollment.Policy Mailing Zip Code (refer to TDIC invoice):',
        defaultMessage: 'Policy Mailing Zip Code (refer to TDIC invoice):'
    },
    enrollmentPolicyNumber: {
        id: 'enrollment.components.enrollment.Policy Number:',
        defaultMessage: 'Policy Number:'
    },
    returnToHomePage: {
        id: 'enrollment.components.enrollment.Return to Home Page',
        defaultMessage: 'Return to Home Page'
    },
    enrollmentFailed: {
        id: 'tdic.enrollment.components.enrollment.We are unable to create an account with the policy number provided. Your information may have been entered incorrectly, or your policy may not yet be eligible for online access. Re-enter your policy number and zip code or learn more about online access',
        defaultMessage: 'We are unable to create an account with the policy number provided. Your information may have been entered incorrectly, or your policy may not yet be eligible for online access. Re-enter your policy number and zip code or {link} about online access'
    },
    inactiveContact: {
        id: 'tdic.enrollment.components.enrollment.We are unable to create an account with the policy number provided. Your information may have been entered incorrectly, or your policy may not be eligible for online access. Re-enter your policy number and zip code or learn more about online access',
        defaultMessage: 'We are unable to create an account with the policy number provided. Your information may have been entered incorrectly, or your policy may not be eligible for online access. Re-enter your policy number and zip code or {link} about online access'
    },
    enrollmentInvalid: {
        id: 'tdic.enrollment.components.enrollment.Entered Policy number, ADA number and zip code do not match.',
        defaultMessage: 'Entered Policy number, ADA number and zip code do not match. {link}.'
    },
    enrollmentInvalidLinkText: {
        id: 'tdic.enrollment.components.enrollment.Where to find this information',
        defaultMessage: 'Where to find this information'
    },
    accountExist: {
        id: 'enrollment.components.enrollment.Account already exists. {link}',
        defaultMessage: 'Account already exists. {link}'
    },
    enrollmentSuccess: {
        id: 'enrollment.components.enrollment.Enrollment Successful',
        defaultMessage: 'Enrollment Successful'
    },
    fieldEmpty: {
        id: 'enrollment.components.enrollment.Enter your policy number, ADA number and the first 5 digits from your policy mailing zip code to associate your policy with this account.',
        defaultMessage: 'Enter your policy number, ADA number and the first 5 digits from your policy mailing zip code to associate your policy with this account.'
    },
    accessToYourPolicies: {
        id: 'enrollment.components.enrollment.You now have access to your policies:',
        defaultMessage: 'You now have access to your policies:'
    },
    accessToYourPolicy: {
        id: 'enrollment.components.enrollment.You now have access to your policy:',
        defaultMessage: 'You now have access to your policy:'
    },
    adaNumber: {
        id: 'tdic.enrollment.components.enrollment.ADA Number:',
        defaultMessage: 'ADA Number:'
    },
    signIn: {
        id: 'tdic.enrollment.components.enrollment.Sign In',
        defaultMessage: 'Sign In'
    },
    learnMore: {
        id: 'tdic.enrollment.components.enrollment.learn more',
        defaultMessage: 'learn more'
    },
    alreadyHasADANumber: {
        id: 'enrollment.components.enrollment.User already enrolled with ADA number',
        defaultMessage: 'User already enrolled with ADA number'
    },
});
